import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {ChronieMaintenanceWindow} from '../../../../shared/interface/chronie-maintenance-window';
import {ChronieMaintenanceWindowService} from '../../../../shared/services/chronie-maintenance-window.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-chronie-maintenance-window-details',
  templateUrl: './chronie-maintenance-window-details.component.html',
  styleUrls: ['./chronie-maintenance-window-details.component.scss']
})
export class ChronieMaintenanceWindowDetailsComponent implements OnInit, OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);

  maintenanceId: string;
  maintenanceObject?: ChronieMaintenanceWindow;
  maintenance = new ReplaySubject<ChronieMaintenanceWindow>(1);
  modify = false;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private maintenanceWindowService: ChronieMaintenanceWindowService,
    private snack: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.maintenanceId = params.id;
        this.loadData();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadData(): void {
    this.loading = true;

    this.maintenanceWindowService.get(this.maintenanceId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: maintenance => {
          this.loading = false;
          this.maintenance.next(maintenance);
          this.maintenanceObject = maintenance;
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.snack.open(
            'Nie udało się pobrać danych konfiguracji',
            error.status.toString(),
            {duration: 2000}
          );
        }
      });
  }
}
